import { Center, Flex, Show } from "@chakra-ui/react";
import { Section, SubTitle, Title } from "../utils";
import EmailModal from "./Email";

const Subsribe = () => {
  return (
    <Section>
      <Flex
        flexDir="column"
        gap={{ base: "8px", md: "16px" }}
        alignItems={{ base: "flex-start", md: "center" }}
      >
        <Title>
          <Show above="769px">Stay updated with Kelp</Show>
          <Show below="md">
            Stay <br /> updated with Kelp
          </Show>
        </Title>

        <SubTitle>
          Join a community of 200k+ users and never miss out on exclusive
          rewards
        </SubTitle>
      </Flex>

      <Center justifyContent={{ base: "flex-start", md: "center" }} w="100%">
        <EmailModal />
      </Center>
    </Section>
  );
};

export default Subsribe;
